import { type LocalStorageKeyInput } from './base/localStorage.key';

import useScopedKeyInput, { type ScopedKeyOptions } from './useScopedKeyInput';
import useLocalStorageUtils from './useLocalStorageUtils';

// when you don't need the state and want to cut it out for fewer rerenders
const useScopedLocalStorageUtils = <T>(
  keyInput: LocalStorageKeyInput,
  options?: ScopedKeyOptions,
) => {
  const scopedKeyInput = useScopedKeyInput(keyInput, options);

  return useLocalStorageUtils<T>(scopedKeyInput);
};

export default useScopedLocalStorageUtils;
